<template>
  <div class="banner">
    <div class="slogan" v-html="slogan">
    </div>
    <div style="height: 3rem;"></div>
    <Download></Download>
    <div style="height: 1rem;"></div>
    <div class="record">
      <div>
        <div class="number">全球 <i>{{renshu}}</i>+ 用户的信赖之选</div>
      </div>
    </div>
    <div class="poster">
      <img src="@/assets/images/banner.jpg" alt="">
    </div>
  </div>
</template>

<script>
  import Download from "./Download"
  import utils from "../utils/utils"
  import { computed, ref } from "vue"

  export default {
    name: 'Banner',
    components: {
      Download
    },
    setup () {


      let renshu = computed(() => {
        return utils.commalize(val.value.toString())
      })
      let val = ref(1000000)
      let env = window.env
      return {
        env,
        val,
        renshu,
      }
    },
    created () {
      let valNumber = utils.getHashNumber(this.appName, 111111)
      let valTimeNumber = new Date().getTime()
      this.val = valNumber + utils.subNumber(valTimeNumber)
      setInterval( ()=> {
        this.val++
      }, 1000*60)
    }

  }
</script>

<style scoped>

  img {
    width: 100%;
  }

  .banner {
    color: #ffffff;
    text-align: center;
    align-items: center;
    display: flex;
    flex-direction: column;
    padding: 5rem 0 1rem 0;
    background-color: #49a79f;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    overflow: hidden;
  }


  .slogan {
    padding: 1rem;
    font-size: 3.5rem;
    font-weight: 800;
    line-height: 1.2;
    letter-spacing: -1px;
    text-shadow: 0 2px 20px rgba(0,0,0,0.2);
    position: relative;
    z-index: 1;
    animation: fadeInUp 0.8s ease;
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .record {
    text-align: center;
    padding: 1.5rem 10%;
    width: 100%;
    position: relative;
    z-index: 1;
  }

  .record .number {
    background: rgba(255,255,255,0.15);
    backdrop-filter: blur(10px);
    padding: 0.8rem 2rem;
    border-radius: 50px;
    display: inline-block;
    font-size: 1.1rem;
    font-weight: 500;
    letter-spacing: 0.5px;
  }

  .record .number i {
    font-style: normal;
    font-weight: 700;
    color: #ffd700;
    font-size: 1.3rem;
  }

  .poster {
    display: flex;
    width: 100%;
    max-width: 500px;
    position: relative;
    z-index: 1;
    margin-top: 2rem;
  }

  .link a {
    color: #ffd700;
    text-decoration: none;
    transition: color 0.3s ease;
  }

  .link a:hover {
    color: #fff;
  }

  @media all and (max-width: 800px) {
    .banner {
      padding: 4rem 1.5rem 0 3rem;
    }
    .slogan {
      font-size: 2.2rem;
      font-weight: 700;
      letter-spacing: -0.5px;
    }
    .record .number {
      font-size: 0.95rem;
      padding: 0.6rem 1.5rem;
    }
  }

  @media all and (min-width: 800px) {
    .slogan {
      font-size: 4.5rem;
      letter-spacing: -2px;
      line-height: 1.15;
      max-width: 900px;
    }
    .banner {
      padding: 8rem 2rem 5rem;
    }
  }
</style>
